/**
* @Description 文件功能说明：上传预览弹窗
* @Author 张彬
* @Time 2021/3/13 11:33
**/

/* HTML */
<template>
    <div v-if="dialogTreeItem.dialogFormVisible">
        <el-dialog :title="dialogTreeItem.title"
                   :visible.sync="dialogTreeItem.dialogFormVisible"
                   :close-on-click-modal="false"
                   custom-class="form-dialog"
                   v-dialogDrag
                   :modal-append-to-body="false"
                   class="dialog_title"
                   @close="handleDialogClose"
        >
            <el-form label-width="180px" class="condition-form-item" :model="rowForm" ref="rowForm" :rules="rules">
                <el-form-item label="基站编号：">
                    {{editRangeBs.bsId + " (" + editRangeBs.bsSid + ")"}}
                </el-form-item>
                <el-form-item label="安装序号：" prop="bsSerial">
                    <el-input v-model="rowForm.bsSerial" clearable placeholder="请输入格式：数字 - 数字"/>
                </el-form-item>
                <el-form-item label="安装高度：" prop="pointZ">
                    <el-input v-model="rowForm.pointZ" clearable>
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="基站组：" prop="bsGroupIds">
                    <el-select v-model="rowForm.bsGroupIds" multiple filterable placeholder="请选择基站组" clearable>
                        <el-option v-for="(item,key) in bsGroups" :key="item.groupId" :label="item.groupName" :value="item.groupId"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="相对上一基站的X轴：" prop="directionX">
                    <el-radio-group v-model="rowForm.directionX">
                        <el-radio class="radio" :label="true">正方向</el-radio>
                        <el-radio class="radio" :label="false">反方向</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="相对上一基站的Y轴：" prop="directionY">
                    <el-radio-group v-model="rowForm.directionY">
                        <el-radio class="radio" :label="true">正方向</el-radio>
                        <el-radio class="radio" :label="false">反方向</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="垂直方向：" prop="verticalDirection">
                    <el-radio-group v-model="rowForm.verticalDirection">
                        <el-radio class="radio" :label="1">垂直于X轴</el-radio>
                        <el-radio class="radio" :label="2">垂直于Y轴</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="垂直距离：" prop="verticalDistance">
                    <el-input v-model="rowForm.verticalDistance" clearable>
                        <template slot="append">米</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="排序：" prop="sort">
                    <el-select v-model="rowForm.sort" placeholder="请选择排序">
                        <el-option v-for="(item,index) in sorts" :key="item" :label="item" :value="item" ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item class="row-items-1 btn-form-item-c" >
                    <el-button type="primary" @click.native="submit" size="mini">{{dialogTreeItem.submitButton}}</el-button>
                </el-form-item>
            </el-form>

        </el-dialog>
    </div>

</template>

/* JS */
<script>
import ApiOam from '@/request/api-oam'
import {checkFormat, validFormat} from "@/global/global-valid";
export default {

    /**
     * @Des 组件名
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    name: 'UwbBSRangeEditDialog',

    /**
     * @Des 组件引用
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    components: {
    },

    /**
     * @Des 数据接收类型
     * @Auth Zhangbin
     * @Date 17:22 2021/4/30
     */
    props: {
        editRangeBs: {
            type: Object,
            default: function (){
                return {}
            }
        },
        rangeGroupId: 0,
    },

    /**
     * @Des 数据定义
     * @Auth Zhangbin
     * @Date 17:23 2021/4/30
     */
    data() {
        return{

            /**
             * @Des 弹出层属性
             * @Auth Zhangbin
             * @Date 17:23 2021/4/30
             */
            dialogTreeItem: {
                title: '',
                dialogFormVisible: false,
                submitButton: '',
            },
            rowForm: {
                bsGroupIds: [],
                directionX: true,
                directionY: true,
                verticalDirection: 1,
                verticalDistance: 0,
                pointZ: 3.5,
                bsSerial: '',
                sort: 0,
            },
            bsGroups: [],
            sorts: [],
            rules: {
                bsSerial: [
                    { required: false, message: '安装序号不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            this.rowForm.bsSerial = value != null ? value.trim() : '';
                            if(this.rowForm.bsSerial.length == 0){
                                new callback(new Error("安装序号不能为空"));
                            }else{
                                let split = this.rowForm.bsSerial.split("-");
                                if(split.length != 2 || !checkFormat(split[0], validFormat.num_gte_0) || !checkFormat(split[1], validFormat.num_gte_0)){
                                    new callback(new Error("请输入格式：数字 - 数字"));
                                }else{
                                    callback();
                                }
                            }

                        },
                        trigger: "blur"
                    }
                ],
                bsGroupIds: [
                    { required: false, message: '基站组不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!this.rowForm.bsGroupIds || this.rowForm.bsGroupIds.length == 0) {
                                new callback(new Error("基站组不能为空"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
                verticalDistance: [
                    { required: false, message: '垂直距离不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {

                            if ((value == null || !checkFormat(value, validFormat.float))) {
                                new callback(new Error("输入无效"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
                pointZ: [
                    { required: false, message: '安装高度不能为空', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if ((value == null || !checkFormat(value, validFormat.float))) {
                                new callback(new Error("输入无效"));
                            } else {
                                callback()
                            }
                        },
                        trigger: "blur"
                    }
                ],
            }
        }
    },
    /**
     * @Des 方法定义
     * @Auth Zhangbin
     * @Date 17:24 2021/4/30
     */
    methods: {
        /**
         * @Des 打开弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        openDialog(title, button, data){
            this.dialogTreeItem.title = title;
            this.dialogTreeItem.dialogFormVisible = true;
            this.dialogTreeItem.submitButton = button;
            this.$nextTick(() => {
                if(data.bsGroups){
                    this.bsGroups = data.bsGroups;
                }
                if(data.index){
                    this.rowForm.sort = data.index+1;
                }
                if(this.editRangeBs){
                    this.rowForm.bsGroupIds = this.editRangeBs.bsGroupIds;
                    this.rowForm.bsSerial = this.editRangeBs.bsSerial;
                    this.rowForm.directionX = this.editRangeBs.directionX;
                    this.rowForm.directionY = this.editRangeBs.directionY;
                    this.rowForm.verticalDirection = this.editRangeBs.verticalDirection;
                    this.rowForm.verticalDistance = this.editRangeBs.verticalDistance;
                    this.rowForm.pointZ = this.editRangeBs.pointZ == null ? 3.5 : this.editRangeBs.pointZ;
                }
                if(data.maxSort){
                    this.sorts = [];
                    for(let i=1;i<=data.maxSort;i++){
                        this.sorts.push(i);
                    }
                }
            })
        },

        /**
         * @Des 关闭弹窗
         * @Auth Zhangbin
         * @Date 17:24 2021/4/30
         */
        handleDialogClose(){
            this.dialogTreeItem.dialogFormVisible = false;
            this.$emit("research");
        },

        /**
         * @Des 数据提交
         * @Auth Zhangbin
         * @Date 17:49 2021/4/30
         */
        submit(){
            this.$refs.rowForm.validate(valid => {
                if(!valid) return false;
                this.operationLock = true;
                this.$request.postJsonRequest(ApiOam.Update_Uwb_Range_Bs_Error_Uri, {
                    groupId: this.rangeGroupId,
                    bsGroupIds: this.rowForm.bsGroupIds,
                    bsSid: this.editRangeBs.bsSid,
                    directionX: this.rowForm.directionX,
                    directionY: this.rowForm.directionY,
                    verticalDirection: this.rowForm.verticalDirection,
                    verticalDistance: this.rowForm.verticalDistance,
                    pointZ: this.rowForm.pointZ,
                    bsSerial: this.rowForm.bsSerial,
                    sort: this.rowForm.sort,
                }).then(result => {
                    if(result.code == 0){
                        this.$message({
                            message: '编辑成功',
                            type: 'success',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        this.handleDialogClose();
                        this.$emit("research");
                    }else{
                        this.$message({
                            message: result.msg,
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                    }
                    this.operationLock = false;
                }).catch(error => {
                	this.operationLock = false;
                	console.error('编辑测距基站异常', ApiOam.Update_Uwb_Range_Bs_Error_Uri, error);
                });
            });
        },
    },

}
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 850px;
        height: auto;
	}
	/deep/ .form-dialog .el-select {
		width: auto;
	}
	/deep/ .form-dialog .el-form,
	/deep/ .form-dialog .el-form-item {
		margin-bottom: 0px;
	}
    /deep/ .el-input__inner{
        width: 555px!important;
    }
    /deep/ .form-dialog .el-form-item{
        margin-bottom: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/components_pages/Device/UwbBSRangeEditDialog.vue